export default function omitNullable<T>(array: T[]) {
  return array.filter((item: T) => item !== null && item !== undefined) as NonNullable<T>[];
}
